import { Injectable } from '@angular/core';
import {
  ActivatedRouteSnapshot,
  Router,
  RouterStateSnapshot,
  UrlTree,
} from '@angular/router';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { UserContextService } from './user-context.service';

@Injectable({
  providedIn: 'root',
})
export class WorkspaceSelectedGuard {
  constructor(
    private readonly userContextService: UserContextService,
    private readonly router: Router
  ) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot
  ):
    | Observable<boolean | UrlTree>
    | Promise<boolean | UrlTree>
    | boolean
    | UrlTree {
    return this.userContextService.selectedWorkspace$.pipe(
      map((selectedWorkspace) => {
        if (!selectedWorkspace) {
          const qIdx = state.url.indexOf('?');
          const locationId = qIdx >= 0
            ? new URLSearchParams(state.url.slice(qIdx + 1)).get('location')
            : null;
          return this.router.createUrlTree(['workspace', 'selection'], {
            queryParams: {
              returnUrl: state.url,
              ...(locationId ? { location: locationId } : {}),
            },
          });
        }

        return true;
      })
    );
  }
}
